import {Injectable} from '@angular/core';
import {TokenStorage} from './token.storage';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {InterfaceAccessMatrix} from '@modules/login/interfaces/login.interface';
import {Observable} from 'rxjs';

/**  Класс проверки авторизации пользователя */
@Injectable()
export class AuthGuard implements CanActivate {
    /**
     * Конструктор класса
     * @param router - класс доступа к роутингу
     * @param token - класс для доступа с сохраненной в браузере информации
     */
    constructor(private router: Router, private token: TokenStorage) {
    }

    /**
     * Проверка авторизации и доступа к маршруту
     * @param next - маршрут к которому получаем доступ
     * @param state - параметры, которые необходимо проверить у маршрута
     */
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const isLogin = this.token.getToken() ? JSON.parse(this.token.getToken()) : null;
        const permissions: InterfaceAccessMatrix = this.token.getAccessMatrix();
        const permission = next && next.routeConfig && next.routeConfig.data
        && next.routeConfig.data.permissions ? next.routeConfig.data.permissions : null;

        // Модуль имеет внутреннюю проверку доступа
        if (permission === 'insertPermission') {
            return true;
        }

        // Стандартная проверка доступа
        if (isLogin && permission && permissions[permission] && permissions[permission].show == 1) {
            return true;
        }

        // Если не прошли проверку доступа
        if (isLogin) {
            return this.router.createUrlTree(['page-not-found']);
        }

        // Сохраняем урл с которого нас отправило на логинку
        this.token.setRestoreUrl(state.url);

        return this.router.createUrlTree(['login']);
    }
}
